// extracted by mini-css-extract-plugin
export default {"mod_checkbox":"style__mod_checkbox__ongyq","ui_checkbox":"style__ui_checkbox__iUJb4"};